import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.altButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn btn-pimary tw-flex tw-items-center tw-rounded-full tw-gap-2 tw-bg-[#FFF] tw-text-[#00A0DA] tw-font-medium tw-border-[#00A0DA]",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal()))
        }, [
          _createTextVNode(_toDisplayString(_ctx.buttonLabel) + " ", 1),
          (_ctx.iconClass !== '')
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(_ctx.iconClass)
              }, null, 2))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal()))
        }, [
          (_ctx.iconClass !== '')
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(_ctx.iconClass),
                "aria-hidden": "true"
              }, null, 2))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.buttonLabel), 1)
        ])),
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.name,
      tabindex: "-1",
      "aria-labelledby": "exampleModalLabel1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ], 8, _hoisted_1)
  ], 64))
}